import React, {Component} from 'react';
import {Collapse} from "reactstrap";
import './style.css';

export default class TwoLevelCollapseMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {selectedMenu: -1};
    }

    render() {
        return (
            <div className="com-twolevelcollapsemenu">
                {this.props.menu && this.props.menu.map((l1m, index) =>
                    <div key={index}>
                        <div
                            className={(this.state.selectedMenu === index ? this.props.activeClassName : "") + " level1"}
                            onClick={() => {
                                this.setState({selectedMenu: this.state.selectedMenu === index ? -1 : index});
                                this.props.onMenuClick && this.props.onMenuClick(0, index);
                            }}>{l1m.title}</div>
                        <Collapse key={index} isOpen={this.state.selectedMenu === index}>
                            {l1m.menu && l1m.menu.map((l2m, index2) =>
                                <div
                                    className="level2"
                                    key={index2}
                                    onClick={() => {
                                        this.props.onMenuClick && this.props.onMenuClick(1, [index, index2])
                                    }}
                                >{l2m.title}</div>
                            )}
                        </Collapse>
                    </div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/03-components/TwoLevelCollapseMenu/index.js